import Cookies from 'js-cookie';
import mixpanel from 'mixpanel-browser';
import { lazy, useLayoutEffect } from 'react';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';

import { COOKIE_KEY_MIXPANEL } from '@/constant';
import { NotFoundPage } from '@/pages/NotFoundPage';

const LazyChatWidgetPage = lazy(() => import('@/pages/ChatWidget'));
const LazyBotPage = lazy(() => import('@/pages/Bot'));
const LazyHomePage = lazy(() => import('@/pages/Home'));
const LazyNoAccessPage = lazy(() => import('@/pages/NoAccess'));
const LazyWidgetDemoPage = lazy(() => import('@/pages/ChatWidget/demo'));
const LazyContactPage = lazy(() => import('@/pages/Contact'));
const LazyTermsPage = lazy(() => import('@/pages/Terms'));
const LazyPrivacyPolicyPage = lazy(() => import('@/pages/PrivacyPolicy'));
const LazyOnPremisesTermsPage = lazy(() => import('@/pages/OnPremises/Terms'));
const LazyMaintenanceSupportServiceSpecificationPage = lazy(
  () => import('@/pages/OnPremises/MaintenanceSupportServiceSpecification')
);
const LazyDigitalHumanPage = lazy(() => import('@/pages/DigitalHuman'));
const LazyScreenDigitalHumanPage = lazy(() => import('@/pages/ScreenDigitalHuman'));
const LazyDesktopPage = lazy(() => import('@/pages/Desktop'));

export const AppRoutes = () => {
  // reset mixpanel distinct_id value
  useLayoutEffect(() => {
    const mixpanelCookieValue = Cookies.get(COOKIE_KEY_MIXPANEL);
    if (!mixpanelCookieValue) return;
    const newVal = JSON.parse(mixpanelCookieValue);
    newVal.distinct_id = 'gptbase';
    Cookies.set(COOKIE_KEY_MIXPANEL, JSON.stringify(newVal));
    mixpanel.track('visit', {
      url: window.location.href,
    });
  }, []);

  const BotRedirect = () => {
    const { id } = useParams();
    return <Navigate to={`/bot/${id}`} replace />;
  };

  return (
    <Routes>
      <Route path="/404" element={<NotFoundPage />} />
      <Route path="/bot/:id" element={<LazyBotPage />} />
      <Route path="/completions/:id" element={<BotRedirect />} />
      <Route path="/ai/:id" element={<BotRedirect />} />
      <Route path="/widget/:id" element={<LazyChatWidgetPage />} />
      <Route path="/widget-demo" element={<LazyWidgetDemoPage />} />
      <Route path="/*" element={<LazyHomePage />} />
      <Route path="/privacy-policy" element={<LazyPrivacyPolicyPage />} />
      <Route path="/privacy" element={<LazyPrivacyPolicyPage />} />
      <Route path="/terms-of-use" element={<LazyTermsPage />} />
      <Route path="/terms" element={<LazyTermsPage />} />
      <Route path="/on-premises/terms-of-use" element={<LazyOnPremisesTermsPage />} />
      <Route
        path="/on-premises/maintenance-support-service-specification"
        element={<LazyMaintenanceSupportServiceSpecificationPage />}
      />
      <Route path="/no-access" element={<LazyNoAccessPage />} />
      <Route path="/contact" element={<LazyContactPage />} />
      {/* <Route path="*" element={<Navigate to="/404" />} /> */}
      <Route path="/digital-human/:id" element={<LazyDigitalHumanPage />} />
      <Route path="/screen-digital-human/:id" element={<LazyScreenDigitalHumanPage />} />
      <Route path="/desktop/:id" element={<LazyDesktopPage />} />
    </Routes>
  );
};
